export enum PlanType {
    FREE="0",
    BASIC = "1",
    PREMIUM = "2",
    BUNDLE = "3",
    LIFETIME = "4"
}